
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.463 2.457H2.24l1.448-1.384a.607.607 0 00.196-.444.607.607 0 00-.196-.445.68.68 0 00-.93 0L.186 2.641a.653.653 0 00-.14.202.643.643 0 000 .478c.031.078.079.15.14.21l2.572 2.457a.71.71 0 00.465.185.692.692 0 00.465-.185.607.607 0 00.196-.444.607.607 0 00-.196-.445L2.24 3.715h6.223c1.793 0 3.247 1.39 3.247 3.103v1.82c.01 1.673-1.375 3.05-3.125 3.104H1.652c-.363 0-.658.281-.658.629 0 .347.295.629.658.629h6.96c2.457-.077 4.403-2.011 4.388-4.361v-1.82c0-2.4-2.027-4.348-4.537-4.362z","fill":"#fff"}})])
          )
        }
      }
    